module.exports = __webpack_public_path__ + "img/angststoerungen1_1280.c772af8c.png";